export default __webpack_public_path__ + "static/media/venus.c2c5379c.png";